import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import StripeCheckout from './stripe_checkout'
import LoggedPreSignup from './logged_presignup'


  class Pricing extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        show_payment_button: false,
        plan: '',
        show_logged_presignup: false,
        presignup_render: ''
      };
      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.ActionDecide = (plan) => {
        const { cookies } = this.props;
        this.setState({plan: plan})

        if (window.location.pathname == '/pricing'){
          if(cookies.get('token')!=null){
            // this.setState({show_payment_button: true})
            if (plan == 'Basic'){
              this.setState({presignup_render: 'weekly_schedule', show_logged_presignup: true})
            }else if (plan == 'Premium'){
              // this.setState({presignup_render: 'trainers_page'}); 
              let port = (window.location.port ? ':' + window.location.port : '');
              window.location.href = '//' + window.location.hostname + port + '/trainers';
            }
          }else{
            let port = (window.location.port ? ':' + window.location.port : '');
            window.location.href = '//' + window.location.hostname + port + '/signup/user/' + plan;
          }
        }else{
          if (plan == 'Basic'){
            this.props.ChangeCurrentRender('weekly_schedule');
            this.props.SetPlan('Basic');
          }else if (plan == 'Premium'){
            this.props.ChangeCurrentRender('trainers_page'); 
            this.props.SetPlan('Premium');
          }
        }
      }

      this.PaymentSuccessful = () => {
        var plan = this.state.plan
      
        const { cookies } = this.props;
  
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('plan', plan)
  
        axios.post(Backend_Url + 'updateUserPlan', data)
        .then((res) => {
            let result = res.data
            alert('Your ' + plan + ' plan has been activated successfully.')
        }).catch((error) => {
            console.log(error)
            this.PaymentSuccessful()
        })
      }

      this.PaymentButton = () => {
        var show_button = this.state.show_payment_button

        if (show_button == true){
          return<StripeCheckout price={9.99} origin='basic_plan' PaymentSuccessful={this.PaymentSuccessful}/>
        }else{
          return<div>

          </div>
        }
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)

      // const { cookies } = this.props;
      // if(cookies.get('token')!=null){
      //   this.setState({show_payment_button: true})
      // }
    }




    render() {
      if (this.state.show_logged_presignup == true){
        return <LoggedPreSignup plan={this.state.plan} presignup_render={this.state.presignup_render}/>
      }
      return (
        <div style={{minHeight: '550px'}}>
            <Helmet>
              <title>PRICING - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <Container>
              <br/><br/>
              <h3 style={{color: '#3C1874', fontWeight: 'bold'}}>
                  ONFIT PLANS
              </h3>
              <br/><br/>
              <Row style={{justifyContent: 'center'}}>
                <Col sm='5' style={{backgroundColor: '#FFFFFF', margin: '10px', minHeight: '400px', width: '300px', boxShadow: '0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12)'}}>
                  <h5 style={{marginTop: '30px', color: '#47525E', fontSize: '25px', textAlign: 'center'}}>
                    Basic Pre-sign up
                  </h5>
                  <h5 style={{marginTop: '30px', color: '#47525E', fontSize: '25px', textAlign: 'center'}}>
                    € <span style={{fontSize: '60px', lineHeight: '51px'}}>9.99</span> 
                    <br/><br/>
                    <span style={{fontWeight: '', fontSize: '20px'}}>P/M</span>
                  </h5>
                  <p style={{color: '#8190A5', fontSize: '14px', lineHeight: '34px', textAlign: 'center'}}>
                    Complete the application form if interested in the Basic Plan Pre-sign up. No credit card 
                    required but spaces for the programs may be limited at the start so access will be granted 
                    on a first come basis.
                  </p>
                  <p style={{marginTop: '30px', color: '#8190A5', fontSize: '18px', lineHeight: '34px', textAlign: 'center'}}>
                    3 Live Two-Way interactive video sessions per week with a Personal trainer
                    <br/><br/>
                    Work out plan
                    <br/><br/>
                    Unlimited Video Exercise Library
                    <br/><br/>
                    Data tracking from fitness watch and smartphone for assistance
                  </p>
                  <Button onClick={() => this.ActionDecide('Basic')} style={{backgroundColor: '#3C1874', color: '#FFFFFF', border: 'none', borderRadius: '20px', minWidth: '30%'}}>
                    Choose Plan
                  </Button>
                  <this.PaymentButton/>
                  <br/><br/><br/><br/>
                </Col>
                <Col sm='5' style={{backgroundColor: '#FFFFFF', margin: '10px', minHeight: '400px', width: '300px', boxShadow: '0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12)'}}>
                  <h5 style={{marginTop: '30px', color: '#47525E', fontSize: '25px', textAlign: 'center'}}>
                    Premium
                  </h5>
                  
                  <p style={{marginTop: '150px', color: '#8190A5', fontSize: '18px', lineHeight: '34px', textAlign: 'center'}}>
                    Choose your own personal trainer
                    <br/><br/>
                    Personalised Training Schedule
                    <br/><br/>
                    Nutrional Plan 
                    <br/><br/>
                    Videos Library
                  </p>
                  <Button onClick={() => this.ActionDecide('Premium')} style={{backgroundColor: '#3C1874', color: '#FFFFFF', border: 'none', borderRadius: '20px', minWidth: '30%'}}>
                    Choose Plan
                  </Button>
                  <br/><br/><br/><br/>
                </Col>
              </Row>
            </Container>
            <br/><br/><br/>
        </div>
      );
    }

  };
  
  export default withCookies(Pricing);